// @flow

import React from 'react';
import type { Node } from 'react';
import styled from 'styled-components';
import { Button as BSButton } from 'reactstrap';
import { ThemeColors } from 'trustar-2.0/themes/default';
import type { TextColorType } from 'trustar-2.0/types';
import { Label as BSLabel } from 'reactstrap';
import { pick } from 'ramda';

type LabelPropType = {
  children: ?Node,
  for?: string,
  inline?: boolean,
  className: ?string,
};

export const Label = (props: LabelPropType) => {
  const Label = styled(BSLabel)`
    && {
      display: ${ props.inline ? 'inline-block' : 'block'};
      font-weight: ${ props.inline ? 'normal' : 600};
      line-height: ${ props.inline ? '1rem' : '1.83rem'};
      font-size: ${ props.inline ? '1rem' : '1.33rem'};
      margin-bottom: ${ props.inline ? '0' : '.5rem'};
    }
  `;

  // $FlowFixMe: Ramda flow error.
  const labelProps = pick(['children', 'for', 'className'], props);
  return <Label {...labelProps} />;
};

Label.defaultProps = {
  for: '',
  inline: false,
};

export default Label;


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/Form/Label.js